<template>
  <div>
    <DialogBase panel-title="Thông tin chung" panel-subtitle="Vui lòng điền đầy đủ thông tin" panel-icon="el-icon-document-add"
        :title="'Thêm thời khóa biểu'"
        :visible.sync="dialogVisible"
        size="xl"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="2vh"
    >
      <el-form
          label-width="140px"
          label-position="left"
          :model="createMultiSchedule"
          ref="createMultiSchedule"
      >
        <el-row :gutter="20" style="margin-bottom: 15px">
          <el-col :span="14">
            <el-form-item label="Áp dụng tuần" label-width="120px" required>
              <div style="display: flex; gap: 8px;">
                <el-date-picker
                    v-model="createTimeSchedule"
                    type="week"
                    value-format="yyyy-MM-dd"
                    format="Tuần WW"
                    placeholder="Chọn tuần"
                    :clearable="false"
                    style="width: 140px"
                    @change="getValueDateSchedule(createTimeSchedule)"
                ></el-date-picker>
                <el-select
                    style="flex: 1;"
                    v-model="listCreateTimeSchedule"
                    multiple
                    @change="changeWeek()"
                    placeholder="Các tuần đã chọn"
                ></el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Chọn lớp" label-width="90px" required>
              <el-select
                  v-model="createMultiSchedule.listIdClass"
                  placeholder="Chọn lớp"
                  clearable
                  style="width: 100%"
                  :multiple="true"
              >
                <el-option
                    v-for="item in listClass"
                    :key="item.id"
                    :label="item.className"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-tabs type="card" v-model="activeNameTab">

          <!--     Tab thứ 2     -->
          <el-tab-pane label="Thứ 2" name="monday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="createMultiSchedule.createTabAllSchedule[0].createTabDayInWeek"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentSchedule"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentSchedule"
                        :rows="2"
                        placeholder="Nhập nội dung học..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="Tác vụ"
                    align="center"
                    width="120">
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="success" icon="el-icon-plus" circle @click="addRowTableMonday(scope.row.sessionDay)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 0)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item label="Chủ đề" label-width="70px" style="margin-top: 15px; margin-bottom: 0">
              <el-input
                  placeholder="Nhập chủ đề..."
                  v-model="createMultiSchedule.createTabAllSchedule[0].scheduleTitle"
                  clearable
                  prefix-icon="el-icon-notebook-1"
                  style="width: 400px"
              >
              </el-input>
            </el-form-item>
          </el-tab-pane>

          <!--     Tab thứ 3     -->
          <el-tab-pane label="Thứ 3" name="tuesday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="createMultiSchedule.createTabAllSchedule[1].createTabDayInWeek"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    width="150px"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentSchedule"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentSchedule"
                        :rows="2"
                        placeholder="Nhập nội dung học..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="Tác vụ"
                    align="center"
                    width="120">
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="success" icon="el-icon-plus" circle @click="addRowTableTuesday(scope.row.sessionDay)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 1)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item label="Chủ đề" label-width="70px" style="margin-top: 15px; margin-bottom: 0">
              <el-input
                  placeholder="Nhập chủ đề..."
                  v-model="createMultiSchedule.createTabAllSchedule[1].scheduleTitle"
                  clearable
                  prefix-icon="el-icon-notebook-1"
                  style="width: 400px"
              >
              </el-input>
            </el-form-item>
          </el-tab-pane>

          <!--     Tab thứ 4     -->
          <el-tab-pane label="Thứ 4" name="wednesday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="createMultiSchedule.createTabAllSchedule[2].createTabDayInWeek"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentSchedule"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentSchedule"
                        :rows="2"
                        placeholder="Nhập nội dung học..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="Tác vụ"
                    align="center"
                    width="120">
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="success" icon="el-icon-plus" circle @click="addRowTableWednesday(scope.row.sessionDay)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 2)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item label="Chủ đề" label-width="70px" style="margin-top: 15px; margin-bottom: 0">
              <el-input
                  placeholder="Nhập chủ đề..."
                  v-model="createMultiSchedule.createTabAllSchedule[2].scheduleTitle"
                  clearable
                  prefix-icon="el-icon-notebook-1"
                  style="width: 400px"
              >
              </el-input>
            </el-form-item>
          </el-tab-pane>

          <!--     Tab thứ 5     -->
          <el-tab-pane label="Thứ 5" name="thursday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="createMultiSchedule.createTabAllSchedule[3].createTabDayInWeek"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentSchedule"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentSchedule"
                        :rows="2"
                        placeholder="Nhập nội dung học..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="Tác vụ"
                    align="center"
                    width="120">
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="success" icon="el-icon-plus" circle @click="addRowTableThursday(scope.row.sessionDay)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 3)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item label="Chủ đề" label-width="70px" style="margin-top: 15px; margin-bottom: 0">
              <el-input
                  placeholder="Nhập chủ đề..."
                  v-model="createMultiSchedule.createTabAllSchedule[3].scheduleTitle"
                  clearable
                  prefix-icon="el-icon-notebook-1"
                  style="width: 400px"
              >
              </el-input>
            </el-form-item>
          </el-tab-pane>

          <!--     Tab thứ 6     -->
          <el-tab-pane label="Thứ 6" name="friday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="createMultiSchedule.createTabAllSchedule[4].createTabDayInWeek"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="text"
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentSchedule"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentSchedule"
                        :rows="2"
                        placeholder="Nhập nội dung học..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="Tác vụ"
                    align="center"
                    width="120">
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="success" icon="el-icon-plus" circle @click="addRowTableFriday(scope.row.sessionDay)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 4)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item label="Chủ đề" label-width="70px" style="margin-top: 15px; margin-bottom: 0">
              <el-input
                  placeholder="Nhập chủ đề..."
                  v-model="createMultiSchedule.createTabAllSchedule[4].scheduleTitle"
                  clearable
                  prefix-icon="el-icon-notebook-1"
                  style="width: 400px"
              >
              </el-input>
            </el-form-item>
          </el-tab-pane>

          <!--     Tab thứ 7     -->
          <el-tab-pane label="Thứ 7" name="saturday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="createMultiSchedule.createTabAllSchedule[5].createTabDayInWeek"
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentSchedule"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentSchedule"
                        :rows="2"
                        placeholder="Nhập nội dung học..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="Tác vụ"
                    align="center"
                    width="120">
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="success" icon="el-icon-plus" circle @click="addRowTableSaturday(scope.row.sessionDay)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 5)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item label="Chủ đề" label-width="70px" style="margin-top: 15px; margin-bottom: 0">
              <el-input
                  placeholder="Nhập chủ đề..."
                  v-model="createMultiSchedule.createTabAllSchedule[5].scheduleTitle"
                  clearable
                  prefix-icon="el-icon-notebook-1"
                  style="width: 400px"
              >
              </el-input>
            </el-form-item>
          </el-tab-pane>

          <!--     Tab CN     -->
          <el-tab-pane label="CN" name="sunday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :header-cell-style="tableHeaderColor"
                  :data="createMultiSchedule.createTabAllSchedule[6].createTabDayInWeek"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentSchedule"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentSchedule"
                        :rows="2"
                        placeholder="Nhập nội dung học..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="Tác vụ"
                    align="center"
                    width="120">
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="success" icon="el-icon-plus" circle @click="addRowTableSunday(scope.row.sessionDay)"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 6)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item label="Chủ đề" label-width="70px" style="margin-top: 15px; margin-bottom: 0">
              <el-input
                  placeholder="Nhập chủ đề..."
                  v-model="createMultiSchedule.createTabAllSchedule[6].scheduleTitle"
                  clearable
                  prefix-icon="el-icon-notebook-1"
                  style="width: 400px"
              >
              </el-input>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <template #footer>
      <div class="tab-infor-button">
        <el-button
            type="danger"
            size="medium"
            @click="closeDialogByButton('createMultiSchedule')"
        >
          <i class="el-icon-circle-close"/>
          <span>Đóng</span>
        </el-button>
        <el-button
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm('createMultiSchedule')"
        >
          <i class="el-icon-circle-check"/>
          <span>Lưu</span>
        </el-button>
      </div>
      </template>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ScheduleService from "@/services/ScheduleService";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  components: { DialogBase },
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      createTimeSchedule: "",
      listTimeSchedule: "",
      listCreateTimeSchedule: [],
      activeNameTab: "monday",
      value: "",
      // listClass: [],
      loadingButton: false,
      createMultiSchedule: {
        createTabAllSchedule: [
          {
            scheduleTitle: "",
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentSchedule: "",
              },
            ],
          },
          {
            scheduleTitle: "",
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentSchedule: "",
              },
            ],
          },
          {
            scheduleTitle: "",
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentSchedule: "",
              },
            ],
          },
          {
            scheduleTitle: "",
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentSchedule: "",
              },
            ],
          },
          {
            scheduleTitle: "",
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentSchedule: "",
              },
            ],
          },
          {
            scheduleTitle: "",
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentSchedule: "",
              },
            ],
          },
          {
            scheduleTitle: "",
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentSchedule: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentSchedule: "",
              },
            ],
          },
        ],
        weekSchedule: [],
        listIdClass: "",
      },
    };
  },
  created() {
    if (this.getAppTypeUserLogin === "plus") {
      this.$store.dispatch('classStore/fetchDataClassListCommon');
    }
    if (this.getAppTypeUserLogin === "teacher") {
      this.$store.dispatch('classStore/fetchDataClassInTeacher')
    }
  },
  computed: {
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    ...mapGetters('classStore', ['classListCommon']),
    ...mapGetters('classStore', ['classInTeacher']),

    // eslint-disable-next-line vue/return-in-computed-property
    listClass() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon;
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      }
    },
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;border:1px solid #fff";
    },
    changeWeek() {
      let c = this.listCreateTimeSchedule;
      this.createMultiSchedule.weekSchedule = [];
      c.forEach((element) => {
        {
          let date = element.slice(-11, -1);
          let newdate = date.split("-").reverse().join("-");
          this.createMultiSchedule.weekSchedule.push(newdate);
        }
      });
    },
    closeDialog() {
      this.$refs["createMultiSchedule"].resetFields();
      this.$emit("dialog-close");
      this.resetData();
    },
    //click when click button
    closeDialogByButton(fromData) {
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
      this.resetData();
    },
    resetData() {
      this.activeNameTab = "monday";
      this.createMultiSchedule.scheduleTitle = "";
      this.createMultiSchedule.listIdClass = [];
      this.createMultiSchedule.weekSchedule = [];
      this.createTimeSchedule = "";
      this.listCreateTimeSchedule = [];
      this.createMultiSchedule.createTabAllSchedule.forEach((x) => {
        x.scheduleTitle = "";
        x.createTabDayInWeek.forEach((y) => {
          y.timeContent = "";
          y.contentSchedule = "";
        });
      });
    },
    handleClose(done) {
      this.$confirm("Are you sure to close this dialog?")
          .then((_) => {
            console.log(_);
            done();
          })
          .catch((_) => {
            console.log(_);
          });
    },
    submitForm(fromData) {
      this.loadingButton = true;
      if (
          this.createMultiSchedule.listIdClass.length > 0 &&
          this.createMultiSchedule.weekSchedule.length > 0
      ) {
        ScheduleService.createMultiScheduleForClass(this.createMultiSchedule)
            .then((response) => {
              console.log(response.data.data);
              this.$message({
                message: "Thêm mới thời khóa biểu thành công",
                type: "success",
              });
              setTimeout(() => {
                this.closeDialogByButton(fromData);
              }, 500);
            })
            .catch((err) => {
              this.$message({
                message: "Thêm mới thời khóa biểu thất bại",
                type: "error",
              });

              console.log(err);
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
      } else {
        this.$message({
          message: "Bạn phải chọn lớp và tuần áp dụng",
          type: "error",
        });
      }
    },

    deleteRow(index, day) {
      let sessionMorning = this.createMultiSchedule.createTabAllSchedule[
          day
          ].createTabDayInWeek.filter((item) => item.sessionDay === "Sáng");
      if (sessionMorning.length > 1) {
        this.createMultiSchedule.createTabAllSchedule[
            day
            ].createTabDayInWeek.splice(index, 1);
      }

      let sessionAfternoon = this.createMultiSchedule.createTabAllSchedule[
          day
          ].createTabDayInWeek.filter((item) => item.sessionDay === "Chiều");
      if (sessionAfternoon.length > 1) {
        this.createMultiSchedule.createTabAllSchedule[
            day
            ].createTabDayInWeek.splice(index, 1);
      }

      let sessionEvening = this.createMultiSchedule.createTabAllSchedule[
          day
          ].createTabDayInWeek.filter((item) => item.sessionDay === "Tối");
      if (sessionEvening.length > 1) {
        this.createMultiSchedule.createTabAllSchedule[
            day
            ].createTabDayInWeek.splice(index, 1);
      }
    },
    addRowTableMonday(data) {
      let indexOf =
          this.createMultiSchedule.createTabAllSchedule[0].createTabDayInWeek.findIndex(
              (element) => element.sessionDay === data
          );
      if (data === "Sáng") {
        this.createMultiSchedule.createTabAllSchedule[0].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Sáng",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Chiều") {
        this.createMultiSchedule.createTabAllSchedule[0].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Chiều",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Tối") {
        this.createMultiSchedule.createTabAllSchedule[0].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Tối",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      }
    },
    addRowTableTuesday(data) {
      let indexOf =
          this.createMultiSchedule.createTabAllSchedule[1].createTabDayInWeek.findIndex(
              (element) => element.sessionDay === data
          );
      if (data === "Sáng") {
        this.createMultiSchedule.createTabAllSchedule[1].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Sáng",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Chiều") {
        this.createMultiSchedule.createTabAllSchedule[1].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Chiều",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Tối") {
        this.createMultiSchedule.createTabAllSchedule[1].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Tối",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      }
    },
    addRowTableWednesday(data) {
      let indexOf =
          this.createMultiSchedule.createTabAllSchedule[2].createTabDayInWeek.findIndex(
              (element) => element.sessionDay === data
          );
      if (data === "Sáng") {
        this.createMultiSchedule.createTabAllSchedule[2].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Sáng",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Chiều") {
        this.createMultiSchedule.createTabAllSchedule[2].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Chiều",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Tối") {
        this.createMultiSchedule.createTabAllSchedule[2].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Tối",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      }
    },
    addRowTableThursday(data) {
      let indexOf =
          this.createMultiSchedule.createTabAllSchedule[3].createTabDayInWeek.findIndex(
              (element) => element.sessionDay === data
          );
      if (data === "Sáng") {
        this.createMultiSchedule.createTabAllSchedule[3].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Sáng",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Chiều") {
        this.createMultiSchedule.createTabAllSchedule[3].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Chiều",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Tối") {
        this.createMultiSchedule.createTabAllSchedule[3].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Tối",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      }
    },
    addRowTableFriday(data) {
      let indexOf =
          this.createMultiSchedule.createTabAllSchedule[4].createTabDayInWeek.findIndex(
              (element) => element.sessionDay === data
          );
      if (data === "Sáng") {
        this.createMultiSchedule.createTabAllSchedule[4].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Sáng",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Chiều") {
        this.createMultiSchedule.createTabAllSchedule[4].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Chiều",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Tối") {
        this.createMultiSchedule.createTabAllSchedule[4].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Tối",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      }
    },
    addRowTableSaturday(data) {
      let indexOf =
          this.createMultiSchedule.createTabAllSchedule[5].createTabDayInWeek.findIndex(
              (element) => element.sessionDay === data
          );
      if (data === "Sáng") {
        this.createMultiSchedule.createTabAllSchedule[5].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Sáng",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Chiều") {
        this.createMultiSchedule.createTabAllSchedule[5].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Chiều",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Tối") {
        this.createMultiSchedule.createTabAllSchedule[5].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Tối",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      }
    },
    addRowTableSunday(data) {
      let indexOf =
          this.createMultiSchedule.createTabAllSchedule[6].createTabDayInWeek.findIndex(
              (element) => element.sessionDay === data
          );
      if (data === "Sáng") {
        this.createMultiSchedule.createTabAllSchedule[6].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Sáng",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Chiều") {
        this.createMultiSchedule.createTabAllSchedule[6].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Chiều",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      } else if (data === "Tối") {
        this.createMultiSchedule.createTabAllSchedule[6].createTabDayInWeek.splice(
            indexOf + 1,
            0,
            {
              sessionDay: "Tối",
              contentSchedule: null,
              timeContent: null,
              timeSchedule: this.timeSchedule,
            }
        );
      }
    },

    getValueDateSchedule(createTimeSchedule) {
      // Xử lý ngày trả về từ el-date-picker
      const selectedDate = moment(createTimeSchedule, "YYYY-MM-DD");

      // Lấy ngày đầu tuần (Thứ Hai) và cuối tuần (Chủ Nhật)
      const startOfWeek = selectedDate.startOf("isoWeek").format("DD-MM-YYYY");
      this.createTimeSchedule = createTimeSchedule;
      let a = selectedDate.startOf("isoWeek").format("YYYY-MM-DD");

      let weeknumber = moment(a, "YYYY-MM-DD").isoWeek();

      let formatweek =
          "Tuần " + weeknumber + "(từ " + startOfWeek + ")";
      let indexOfFormatWeek = this.listCreateTimeSchedule.indexOf(formatweek);
      if (indexOfFormatWeek == -1) {
        this.listCreateTimeSchedule.push(formatweek);
      } else {
        this.listCreateTimeSchedule.splice(indexOfFormatWeek, 0);
      }
      let indexOfCreateTimeSchedule =
          this.createMultiSchedule.weekSchedule.indexOf(a);
      if (indexOfCreateTimeSchedule == -1) {
        this.createMultiSchedule.weekSchedule.push(a);
      } else {
        this.createMultiSchedule.weekSchedule.splice(
            indexOfCreateTimeSchedule,
            0
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

// /deep/.el-tabs__nav {
//   background: #a0a19ce0;
// }

// /deep/.el-tabs__item {
//   color: white;
// }

// /deep/.el-tabs__item.is-active {
//   color: white;
//   background: #67c23a;
// }

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

.table-icon-1 {
  width: 30%;
  margin-left: 15%;
  display: inline-block;
}

.table-icon-2 {
  width: 30%;
  margin-right: 15%;
  float: right;
}
</style>
